import React, { Component } from 'react';
import styled from 'react-emotion';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Container } from 'semantic-ui-react';

import { Row } from '~/modules/coreUI/components/layouts/helpers/LinearLayout';
import Spacer from '~/modules/coreUI/components/layouts/helpers/Spacer';
import { Label } from '~/modules/coreUI/components/basic/Labels';
import Icon from '~/modules/coreUI/components/basic/Icon';
import withMedia from '~/modules/core/utils/mediaHelpers/withMedia';
import withDirection from '~/modules/core/utils/mediaHelpers/withDirection';
import ScrollMenu from '~/modules/ecommerceCoreUI/components/scrollMenu/ScrollMenu';

const ArrowIcon = styled(Icon)`
  padding: ${props => 1.25 * props.theme.new.spacer}px ${props => 1.6 * props.theme.new.spacer}px;
  background-color: ${props => props.theme.new.colors.labels.inverted.primary};
  cursor: pointer;
`;

const DepartmentWrapper = styled.div`
  position: relative;
`;

const DepartmentContainer = styled(Container)`
  position: relative;
`;

const Department = styled(Row)`
  width: max-content;
  min-width: ${props => 14 * props.theme.new.spacer}px;
  padding: ${props => 1.5 * props.theme.new.spacer}px;
  background-color: ${props => (props.isActive ? props.theme.new.colors.labels.inverted.primary : props.theme.new.colors.backgrounds.lightPanelHeader)};
  border-top-left-radius: ${props => 0.3 * props.theme.new.spacer}px;
  border-top-right-radius: ${props => 0.3 * props.theme.new.spacer}px;
  user-select: none;
  cursor: pointer;
`;

const TabsContainer = withDirection(styled.div`
  position: relative;
  background-color: ${props => props.theme.new.colors.backgrounds.panel};
`);

const DropdownIcon = styled(Icon)`
  width: ${props => 1.2 * props.theme.new.spacer}px;
`;

const menuStyles = {
  display: 'flex',
  alignItems: 'center',
  backgroundColor: '#f9f9f9',
  userSelect: 'none',
};

export const departmentIsFeatured = (caption) => {
  const allCaptions = ['hot_deals', 'offers', 'discounts', 'featured_department', 'featured_sub_department'];
  return _.includes(allCaptions, caption);
};

class ShopDepartmentsTabs extends Component {
  state={
    clickedDepartment: null,
  }

  handleDepartmentClick = (e, taxon) => {
    this.props.handleDepartmentClick(e, taxon);
    this.setState({ clickedDepartment: taxon.ref_id });
  }

  departmentsMenu = taxons => taxons.map(taxon => (
    <Row key={taxon.ref_id}>
      {this.subDepartmentsMenu(taxon)}
      <Spacer />
    </Row>
  ));

  Arrow = iconName => (
    <ArrowIcon className={`el-icon el-icon-${iconName}`} />
  );

  Icon = taxon => (
    <DropdownIcon
      size="8px"
      emphasized={!this.departmentIsActive(taxon)}
      primary={this.departmentIsActive(taxon)}
      className={this.state.clickedDepartment === taxon.ref_id && this.props.showMenu
        ? 'el-icon el-icon-up-arrow-gray'
        : 'el-icon el-icon-down-arrow-gray'}
    />
  );

  /* menu-item and item classes are important. Don't change. */
  subDepartmentsMenu = taxon => (
    <DepartmentWrapper onClick={e => this.handleDepartmentClick(e, taxon)} className="menu-item" leftAligned>
      <Department className="item" centerJustified isActive={this.departmentIsActive(taxon)}>
        <Label semiBold={this.departmentIsActive(taxon)} primary={this.departmentIsActive(taxon)} emphasized={!this.departmentIsActive(taxon)}>{taxon.name}</Label>
        <Spacer size={0.5} />
        {!departmentIsFeatured(taxon.caption) && this.props.media.minDesktop && this.Icon(taxon)}
      </Department>
    </DepartmentWrapper>
  );

  departmentIsActive = taxon => this.props.activeDepartment === taxon.ref_id;

  render() {
    const {
      activeDepartment,
      taxons,
      media,
      direction,
    } = this.props;
    const menu = this.departmentsMenu(taxons, activeDepartment);

    return (
      <TabsContainer>
        <DepartmentContainer>
          <ScrollMenu
            data={menu}
            alignCenter={false}
            arrowLeft={media.minDesktop ? this.Arrow(direction === 'ltr' ? 'left' : 'right') : null}
            arrowRight={media.minDesktop ? this.Arrow(direction === 'ltr' ? 'right' : 'left') : null}
            hideSingleArrow
            hideArrows
            dragging={this.props.media.maxTablet}
            menuStyle={menuStyles}
          />
        </DepartmentContainer>
      </TabsContainer>
    );
  }
}

ShopDepartmentsTabs.defaultProps = {
  activeDepartment: '',
};

ShopDepartmentsTabs.propTypes = {
  media: PropTypes.shape({
    maxTablet: PropTypes.bool,
    minDesktop: PropTypes.bool,
  }).isRequired,
  activeDepartment: PropTypes.string,
  taxons: PropTypes.arrayOf(PropTypes.shape({
    ref_id: PropTypes.string,
    children: PropTypes.arrayOf(PropTypes.shape({})),
  })).isRequired,
  handleDepartmentClick: PropTypes.func.isRequired,
  direction: PropTypes.string.isRequired,
  showMenu: PropTypes.bool.isRequired,
};

export default withDirection(withMedia(ShopDepartmentsTabs));
